/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [获取供应商合同推送列表↗](http://yapi.yishou.com/project/128/interface/api/33347) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/listSupplyContractPush`
 * @更新时间 `2022-04-21 19:44:30`
 */
const listSupplyContractPushRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyContract/listSupplyContractPush",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [],
        properties: {
            cp_id: { type: "string", description: "记录id" },
            sc_name: { type: "string", description: "合同名字" },
            supply_id: { type: "string", description: "供应商id" },
            status: { type: "string", description: "状态" },
            created_time: { type: "string", description: "创建时间" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        cp_id: { type: "string", description: "记录id" },
                        sc_name: { type: "string", description: "合同名称" },
                        effect_time: { type: "string", description: "生效起止时间" },
                        created_time_admin: { type: "string", description: "创建人/创建时间" },
                        updated_time_admin: { type: "string", description: "修改人/修改时间" },
                        status: { type: "string", description: "状态" },
                        supply_id: { type: "array", items: { type: "string" }, description: "推送供应商id数组" },
                        status_name: { type: "string", description: "状态名字" },
                        start_time: { type: "string", description: "开始时间" },
                        end_time: { type: "string", description: "结束时间" },
                        start_time_type: { type: "string", description: "合同开始时间类型{1:签署立即生效,2:指定开始时间}" },
                    },
                    required: [
                        "cp_id",
                        "sc_name",
                        "effect_time",
                        "created_time_admin",
                        "updated_time_admin",
                        "status",
                        "supply_id",
                        "status_name",
                        "start_time",
                        "end_time",
                        "start_time_type",
                    ],
                },
            },
        },
        required: ["list"],
    },
    requestFunctionName: "listSupplyContractPush",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商合同推送列表↗](http://yapi.yishou.com/project/128/interface/api/33347) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/listSupplyContractPush`
 * @更新时间 `2022-04-21 19:44:30`
 */
export const listSupplyContractPush = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listSupplyContractPushRequestConfig, requestData), ...args);
};
listSupplyContractPush.requestConfig = listSupplyContractPushRequestConfig;
/**
 * 接口 [添加供应商合同推送↗](http://yapi.yishou.com/project/128/interface/api/33351) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/saveSupplyContractPush`
 * @更新时间 `2022-04-18 11:35:44`
 */
const saveSupplyContractPushRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyContract/saveSupplyContractPush",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sc_name", "supply_list[]", "start_time_type", "start_time", "end_time", "sc_content"],
        properties: {
            sc_name: { type: "string", description: "合同名称" },
            "supply_list[]": { type: "string", description: "供应商id数组" },
            start_time_type: { type: "string", description: "开始类型{1:签署立即生效,2:指定开始时间}" },
            start_time: { type: "string", description: "开始时间" },
            end_time: { type: "string", description: "结束时间" },
            sc_content: { type: "string", description: "合同内容" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "saveSupplyContractPush",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [添加供应商合同推送↗](http://yapi.yishou.com/project/128/interface/api/33351) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/saveSupplyContractPush`
 * @更新时间 `2022-04-18 11:35:44`
 */
export const saveSupplyContractPush = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveSupplyContractPushRequestConfig, requestData), ...args);
};
saveSupplyContractPush.requestConfig = saveSupplyContractPushRequestConfig;
/**
 * 接口 [获取供应商合同内容↗](http://yapi.yishou.com/project/128/interface/api/33353) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @请求头 `POST /erp/SupplyContract/getSupplyContractContent`
 * @更新时间 `2022-04-21 14:50:45`
 */
const getSupplyContractContentRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyContract/getSupplyContractContent",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["cp_id"],
        properties: { cp_id: { type: "string", description: "合同记录id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { sc_content: { type: "string", description: "供应商合同内容" } },
        required: ["sc_content"],
    },
    requestFunctionName: "getSupplyContractContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商合同内容↗](http://yapi.yishou.com/project/128/interface/api/33353) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @请求头 `POST /erp/SupplyContract/getSupplyContractContent`
 * @更新时间 `2022-04-21 14:50:45`
 */
export const getSupplyContractContent = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplyContractContentRequestConfig, requestData), ...args);
};
getSupplyContractContent.requestConfig = getSupplyContractContentRequestConfig;
/**
 * 接口 [获取供应商合同签署信息↗](http://yapi.yishou.com/project/128/interface/api/33354) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/getSupplyContractSign`
 * @更新时间 `2022-04-21 14:52:14`
 */
const getSupplyContractSignRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyContract/getSupplyContractSign",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["cp_id"],
        properties: { cp_id: { type: "string", description: "合同记录id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        supply_id: { type: "string", description: "供应商id" },
                        supply_name: { type: "string", description: "供应商名称" },
                        is_sign: { type: "string", description: "是否签署" },
                        sign_time: { type: "string", description: "签署时间" },
                    },
                    required: ["supply_id", "sign_time", "is_sign", "supply_name"],
                },
            },
        },
        required: ["list"],
    },
    requestFunctionName: "getSupplyContractSign",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商合同签署信息↗](http://yapi.yishou.com/project/128/interface/api/33354) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/getSupplyContractSign`
 * @更新时间 `2022-04-21 14:52:14`
 */
export const getSupplyContractSign = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplyContractSignRequestConfig, requestData), ...args);
};
getSupplyContractSign.requestConfig = getSupplyContractSignRequestConfig;
/**
 * 接口 [取消合同推送↗](http://yapi.yishou.com/project/128/interface/api/33355) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @请求头 `POST /erp/SupplyContract/cancelSupplyContractPush`
 * @更新时间 `2022-04-12 14:22:30`
 */
const cancelSupplyContractPushRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyContract/cancelSupplyContractPush",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["cp_id"],
        properties: { cp_id: { type: "string", description: "合同记录id" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "cancelSupplyContractPush",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [取消合同推送↗](http://yapi.yishou.com/project/128/interface/api/33355) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @请求头 `POST /erp/SupplyContract/cancelSupplyContractPush`
 * @更新时间 `2022-04-12 14:22:30`
 */
export const cancelSupplyContractPush = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cancelSupplyContractPushRequestConfig, requestData), ...args);
};
cancelSupplyContractPush.requestConfig = cancelSupplyContractPushRequestConfig;
/**
 * 接口 [爆版获取供应商合同信息详情↗](http://yapi.yishou.com/project/128/interface/api/33362) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /baob/SupplyContract/getSupplyContractDetail`
 * @更新时间 `2022-04-21 16:29:32`
 */
const getSupplyContractDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/SupplyContract/getSupplyContractDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sc_id"],
        properties: { sc_id: { type: "string", description: "供应商合同id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            content: { type: "string", description: "合同内容" },
            tips: { type: "string", description: "提示信息" },
            status: { type: "string", description: "status 0:不可签署（非老板角色） 1:可签署 2:已签署" },
        },
        required: ["content", "tips", "status"],
    },
    requestFunctionName: "getSupplyContractDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [爆版获取供应商合同信息详情↗](http://yapi.yishou.com/project/128/interface/api/33362) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /baob/SupplyContract/getSupplyContractDetail`
 * @更新时间 `2022-04-21 16:29:32`
 */
export const getSupplyContractDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplyContractDetailRequestConfig, requestData), ...args);
};
getSupplyContractDetail.requestConfig = getSupplyContractDetailRequestConfig;
/**
 * 接口 [爆版签订供应商合同↗](http://yapi.yishou.com/project/128/interface/api/33363) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /baob/SupplyContract/signSupplyContract`
 * @更新时间 `2022-04-12 17:24:46`
 */
const signSupplyContractRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/SupplyContract/signSupplyContract",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sc_id"],
        properties: { sc_id: { type: "string", description: "供应商合同id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { sc_name: { type: "string", description: "合同名称" } },
        required: ["sc_name"],
    },
    requestFunctionName: "signSupplyContract",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [爆版签订供应商合同↗](http://yapi.yishou.com/project/128/interface/api/33363) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /baob/SupplyContract/signSupplyContract`
 * @更新时间 `2022-04-12 17:24:46`
 */
export const signSupplyContract = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(signSupplyContractRequestConfig, requestData), ...args);
};
signSupplyContract.requestConfig = signSupplyContractRequestConfig;
/**
 * 接口 [爆版获取供应商合同信息↗](http://yapi.yishou.com/project/128/interface/api/33364) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @请求头 `POST /baob/SupplyContract/listSupplyContract`
 * @更新时间 `2022-04-19 15:33:11`
 */
const listSupplyContractRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/SupplyContract/listSupplyContract",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            wait_sign_contracts: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        sc_id: { type: "string", description: "合同id" },
                        sc_name: { type: "string", description: "合同名字" },
                    },
                    required: ["sc_id", "sc_name"],
                },
                description: "等待签署合同",
            },
            done_sign_contracts: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        sc_id: { type: "string", description: "合同id" },
                        sc_name: { type: "string", description: "合同名字" },
                        start_time: { type: "string", description: "开始时间" },
                        end_time: { type: "string", description: "结束时间" },
                        sign_time: { type: "string", description: "签订时间" },
                        sc_type: { type: "string", description: "合同类型{线上或线下}" },
                        is_pdf: { type: "string", description: "{0:否,1:是}" },
                    },
                    required: ["sc_id", "sc_name", "start_time", "end_time", "sign_time", "sc_type", "is_pdf"],
                },
                description: "完成签署合同",
            },
            is_boss: { type: "string", description: "是否老板{0:否，1:是}" },
            field_2: { type: "string" },
        },
        required: ["wait_sign_contracts", "done_sign_contracts", "is_boss", "field_2"],
    },
    requestFunctionName: "listSupplyContract",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [爆版获取供应商合同信息↗](http://yapi.yishou.com/project/128/interface/api/33364) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @请求头 `POST /baob/SupplyContract/listSupplyContract`
 * @更新时间 `2022-04-19 15:33:11`
 */
export const listSupplyContract = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listSupplyContractRequestConfig, requestData), ...args);
};
listSupplyContract.requestConfig = listSupplyContractRequestConfig;
/**
 * 接口 [erp显示已签署合同详情↗](http://yapi.yishou.com/project/128/interface/api/33375) 的 **请求配置**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/getDoneContractDetail`
 * @更新时间 `2022-04-29 10:50:22`
 */
const getDoneContractDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyContract/getDoneContractDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sc_id"],
        properties: { sc_id: { type: "string", description: "供应商合同id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            sc_name: { type: "string" },
            sc_content: { type: "string", description: "合同内容" },
            sc_type: { type: "string", description: "合同类型{1:线下,2:线上}" },
            scan_image: { type: "string", description: "扫描件" },
        },
    },
    requestFunctionName: "getDoneContractDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [erp显示已签署合同详情↗](http://yapi.yishou.com/project/128/interface/api/33375) 的 **请求函数**
 *
 * @分类 [供应商合同↗](http://yapi.yishou.com/project/128/interface/api/cat_3056)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/SupplyContract/getDoneContractDetail`
 * @更新时间 `2022-04-29 10:50:22`
 */
export const getDoneContractDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getDoneContractDetailRequestConfig, requestData), ...args);
};
getDoneContractDetail.requestConfig = getDoneContractDetailRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/supplyContract.js